/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  container: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    padding: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '16px',
    },
  },
  alert: {
    width: '100%',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },

  alertText: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
  },

  btn: {
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: 500,
  },

  btnIcon: {
    width: '9px',
    height: '9px',
  },

  mandatorySign: {
    color: theme.palette.primary.main,
    fontSize: '16px',
    fontWeight: 500,
  },
});

export default styles;
